import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-chargingstationprofiles',
  templateUrl: './delete-chargingstationprofiles.component.html',
  styleUrls: ['./delete-chargingstationprofiles.component.scss']
})
export class DeleteChargingstationprofilesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
